export default __webpack_public_path__ + "static/media/Mission.9dd8216d.png";